
// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

interface XHistoryListFilterStateType {
    filterDrawerIsOpen?: boolean;
}

export const initialHistoryListFilterState: XHistoryListFilterStateType = {
    filterDrawerIsOpen: false,
};

const reducer = {
    "xHistoryListFilter/FilterDrawer/SetFilterDrawerIsOpen": (
        draft: Draft<XHistoryListFilterStateType>,
        action: { filterDrawerIsOpen: boolean },
    ) => {
        draft.filterDrawerIsOpen = action.filterDrawerIsOpen;
    },
};

const xHistoryListFilter = createTypedReducerWithImmer(initialHistoryListFilterState, reducer);

(reducers as any).xHistoryListFilter = xHistoryListFilter;

export type xHistoryListFilterState = {
    xHistoryListFilter: XHistoryListFilterStateType;
} & ApplicationState;

type xHistoryListFilterReducers = {
    [key: string]: typeof xHistoryListFilter;
};

export type xHistoryListFilterActions = Parameters<xHistoryListFilterReducers[keyof xHistoryListFilterReducers]>[1] | AnyAction;
